<template>
    <EditingDialog 
        :context="context"
        :showSnackbar="true"
        snackbarTextLangConst="lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"
        :additionalSaveFunction="additionalSaveFunction"
        :useAdditionalSaveFunction="true"
        :useDifferentShowDialogProp="true"
    >
        <template v-slot:editForm>
            <v-row>
                <!-- <v-col cols="5">
                    <BaseEditPageDatePicker 
                        context="ReleaseDigitalDistribution"
                        field="DigitalPreRelease"
                        :label="$t('lang_LABEL_RELEASES_CAPTION_DATE_PRERELEASE')"
                        :alvqa="distibutionEditingAlvQa + '-datepicker-prerelease'"
                        :withMargin="false"
                    />
                </v-col> -->
                <v-col cols="5">
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="DigitalRelease"
                        :label="$t('lang_LABEL_RELEASES_CAPTION_DATE_DIGITAL')"
                        :alvqa="alvqa + '-datepicker-digital-release'"
                        :withMargin="false"
                        
                    />
                    <!-- :min="new Date(Date.now() + 12096e5).toISOString().substr(0, 10)" -->
                </v-col>
                <v-col
                    class="mb-3"
                    align-self="center"
                >
                    <BaseCheckbox 
                        :context="context + 'SetForAll'"
                        :label="$t('lang_LABEL_RELEASES_CHECKBOX_CAPTION_SET_FOR_ALL')" 
                        class="mt-0"
                        hideDetails
                        :alvqa="alvqa + '-cwr-checkbox-no-ghost'"
                    />
                </v-col>
            </v-row>
        </template>
    </EditingDialog>
</template>

<script>
import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseEditPageDatePicker from '@/components/_editForm/BaseEditPageDatePicker'
import BaseCheckbox from '@/components/_base/BaseCheckbox'

export default {
    name: "ReleaseDigitalDistributionEditPanelDialog",
    components: {
        EditingDialog,
        BaseEditPageDatePicker,
        BaseCheckbox
    },
    data() {
        return {
            context: "ReleaseDigitalDistribution",
            alvqa: "label-releases-edit-form-digital-distribution-panel-editing-dialog"
        }
    },
    methods: {
        additionalSaveFunction(item) {
            let editedDigitalDate = item.digitalRelease 
            
            // Set the date for all platforms
            if(this.$store.getters.getReleaseDigitalDistributionSetForAllCheckbox === true) {
                this.$store.getters.getReleaseDigitalDistribution.forEach(platform => {
                    platform.digitalRelease = editedDigitalDate

                    if(editedDigitalDate !== null) {
                        platform.selected = 'yes'
                        platform.status = 'pending'
                    } else {
                        platform.selected = 'no'
                        platform.status = null
                    }

                })
            }

            item.selected = editedDigitalDate !== null ? 'yes' : 'no'
            item.status = editedDigitalDate !== null ? 'pending' : null
            this.$store.commit('setReleaseDigitalDistributionSetForAllCheckbox', false)
            
            return item
        }
    }
}
</script>